// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-card:hover{
    /* box-shadow: 0 10px 15px rgb(255 255 255 / 32%), 0 4px 6px rgba(255, 255, 255, 0.62); */
    border-color: #ffc107;
}


.item-card .price-tag{
    position: absolute;
    top: 0.1rem;
    right: 0.1rem;
    display: flex;
    padding: .2em;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 1.2em;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}

.item-card .item-info{
    font-size: 2em;
    position: absolute;
    top: 0;
    left: 0.4rem;
}

.item-card .item-gems{
    position: absolute;
    bottom: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    overflow: hidden;
    height: 2.5em;
    margin-bottom: 0.5em
}

.item-card .item-gems .gem-image{
    background-repeat: no-repeat;
    flex: 1 1;
    max-height: 2.5em;
    max-width: 2.5em;
    aspect-ratio: 1/1; /* Keeps the images square */
}

.item-card-wrap{
    overflow: hidden;
    height: 10em;
    display: flex;
    position: relative;
    max-width: 15em;
    min-width: 12em;
    flex: 1 1 3em;
    border-color: black !important;
}

.item-card{
    position: absolute;
    left: 0;
    right: 0;
    height: 10em;
    display: flex;
    transition: transform 0.3s ease, border 0.5s ease;
    justify-content: center;
    align-items: center;
}
/* .item-card{
    flex: 1 10rem;
    height: 8rem;
    position: relative;
    display: flex !important;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    max-width: 12rem;
} */

.item-card img{
    height: 100% !important;
    max-width: 100%;
    -webkit-user-select: none;
            user-select: none;  /* Prevent image selection */
    -webkit-user-drag: none; /* Prevent dragging in Webkit browsers */
    outline: none; /* Remove blue outline on focus */
}

/* .item-card .item-info{
    height: 30% !important;
    max-width: 100%;
} */
`, "",{"version":3,"sources":["webpack://./src/assets/styles/ItemCard.css"],"names":[],"mappings":"AAAA;IACI,yFAAyF;IACzF,qBAAqB;AACzB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,uLAAuL;AAC3L;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,4BAA4B;IAC5B,SAAO;IACP,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB,EAAE,4BAA4B;AACnD;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,iDAAiD;IACjD,uBAAuB;IACvB,mBAAmB;AACvB;AACA;;;;;;;;;GASG;;AAEH;IACI,uBAAuB;IACvB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB,GAAG,4BAA4B;IAChD,uBAAuB,EAAE,wCAAwC;IACjE,aAAa,EAAE,iCAAiC;AACpD;;AAEA;;;GAGG","sourcesContent":[".item-card:hover{\n    /* box-shadow: 0 10px 15px rgb(255 255 255 / 32%), 0 4px 6px rgba(255, 255, 255, 0.62); */\n    border-color: #ffc107;\n}\n\n\n.item-card .price-tag{\n    position: absolute;\n    top: 0.1rem;\n    right: 0.1rem;\n    display: flex;\n    padding: .2em;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 1.2em;\n    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\n}\n\n.item-card .item-info{\n    font-size: 2em;\n    position: absolute;\n    top: 0;\n    left: 0.4rem;\n}\n\n.item-card .item-gems{\n    position: absolute;\n    bottom: 0;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    overflow: hidden;\n    height: 2.5em;\n    margin-bottom: 0.5em\n}\n\n.item-card .item-gems .gem-image{\n    background-repeat: no-repeat;\n    flex: 1;\n    max-height: 2.5em;\n    max-width: 2.5em;\n    aspect-ratio: 1/1; /* Keeps the images square */\n}\n\n.item-card-wrap{\n    overflow: hidden;\n    height: 10em;\n    display: flex;\n    position: relative;\n    max-width: 15em;\n    min-width: 12em;\n    flex: 1 3em;\n    border-color: black !important;\n}\n\n.item-card{\n    position: absolute;\n    left: 0;\n    right: 0;\n    height: 10em;\n    display: flex;\n    transition: transform 0.3s ease, border 0.5s ease;\n    justify-content: center;\n    align-items: center;\n}\n/* .item-card{\n    flex: 1 10rem;\n    height: 8rem;\n    position: relative;\n    display: flex !important;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    max-width: 12rem;\n} */\n\n.item-card img{\n    height: 100% !important;\n    max-width: 100%;\n    user-select: none;  /* Prevent image selection */\n    -webkit-user-drag: none; /* Prevent dragging in Webkit browsers */\n    outline: none; /* Remove blue outline on focus */\n}\n\n/* .item-card .item-info{\n    height: 30% !important;\n    max-width: 100%;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
